import { change } from 'redux-form';
import moment from 'moment';
import { CSV_DATES_FORM } from './constants';

const onChangeDateForm = (fromDate, toDate, dispatch) => {
  if (toDate && (moment(fromDate).isAfter(toDate))) {
    dispatch(change(CSV_DATES_FORM, 'to', null));
  }
};

export default onChangeDateForm;
